import CurrencyInr from "@/components/common/currency-inr";
import { selectProduct } from "@/store/slices/product";
import React from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";

const ProductDetailsPriceBreakTab = () => {
  const productState = useSelector(selectProduct);

  if (!productState.data || !productState.selectedPrice) {
    return <></>;
  }

  return (
    <>
      <div className="details_text">
        {!!(
          productState.selectedPrice?.gold_value ||
          productState.selectedPrice?.gold2_value
        ) && (
          <p>
            <strong>Gold Value: </strong>
            {!!productState.selectedPrice?.gold_value && (
              <>
                <CurrencyInr
                  value={
                    productState.selectedPrice.discount?.gold_value
                      ? productState.selectedPrice.discount.gold_value
                      : productState.selectedPrice.gold_value
                  }
                />
                {productState.selectedPrice.discount?.gold_value && (
                  <span className="mx-2">
                    <s>
                      <CurrencyInr
                        value={productState.selectedPrice.gold_value}
                      />
                    </s>
                    {productState.selectedPrice.discount
                      ?.gold_rate_discount && (
                      <span className="ms-2">
                        (
                        {
                          productState.selectedPrice.discount
                            ?.gold_rate_discount
                        }
                        )
                      </span>
                    )}
                  </span>
                )}
                ({productState.selectedPrice.gold_purity_display_name})
              </>
            )}
            {!!productState.selectedPrice?.gold2_value && (
              <>
                ,{" "}
                <CurrencyInr
                  value={
                    productState.selectedPrice.discount?.gold2_value
                      ? productState.selectedPrice.discount.gold2_value
                      : productState.selectedPrice.gold2_value
                  }
                />
                {productState.selectedPrice.discount?.gold2_value && (
                  <span className="mx-2">
                    <s>
                      <CurrencyInr
                        value={productState.selectedPrice.gold2_value}
                      />
                    </s>
                    {productState.selectedPrice.discount
                      ?.gold_rate_discount && (
                      <span className="ms-2">
                        (
                        {
                          productState.selectedPrice.discount
                            ?.gold_rate_discount
                        }
                        )
                      </span>
                    )}
                  </span>
                )}
                ({productState.selectedPrice.gold2_purity_display_name})
              </>
            )}
          </p>
        )}
        {!!productState.selectedPrice?.diamond_value && (
          <p>
            <strong>Diamond Value: </strong>
            <CurrencyInr
              value={
                productState.selectedPrice.discount?.diamond_value
                  ? productState.selectedPrice.discount.diamond_value
                  : productState.selectedPrice.diamond_value
              }
            />
            {productState.selectedPrice.discount?.diamond_value && (
              <s className="mx-3">
                {" "}
                <CurrencyInr value={productState.selectedPrice.diamond_value} />
              </s>
            )}
          </p>
        )}
        {!!productState.selectedPrice?.platinum_value && (
          <p>
            <strong>Platinum Value: </strong>
            <CurrencyInr
              value={
                productState.selectedPrice.discount?.platinum_value
                  ? productState.selectedPrice.discount.platinum_value
                  : productState.selectedPrice.platinum_value
              }
            />
            {productState.selectedPrice.discount?.platinum_value && (
              <span className="mx-2">
                <s>
                  <CurrencyInr
                    value={productState.selectedPrice.platinum_value}
                  />
                </s>
                {productState.selectedPrice.discount
                  ?.platinum_rate_discount && (
                  <span className="ms-2">
                    (
                    {
                      productState.selectedPrice.discount
                        ?.platinum_rate_discount
                    }
                    )
                  </span>
                )}
              </span>
            )}
          </p>
        )}
        {!!productState.selectedPrice?.silver_value && (
          <p>
            <strong>Silver Value: </strong>
            <CurrencyInr
              value={
                productState.selectedPrice.discount?.silver_value
                  ? productState.selectedPrice.discount.silver_value
                  : productState.selectedPrice.silver_value
              }
            />
            {productState.selectedPrice.discount?.silver_value && (
              <span className="mx-2">
                <s>
                  <CurrencyInr
                    value={productState.selectedPrice.silver_value}
                  />
                </s>
                {productState.selectedPrice.discount?.silver_rate_discount && (
                  <span className="ms-2">
                    ({productState.selectedPrice.discount?.silver_rate_discount}
                    )
                  </span>
                )}
              </span>
            )}
          </p>
        )}
        {!!productState.selectedPrice?.stone_value && (
          <p>
            <strong>Stone Value: </strong>
            <CurrencyInr
              value={
                productState.selectedPrice.discount?.stone_value
                  ? productState.selectedPrice.discount.stone_value
                  : productState.selectedPrice.stone_value
              }
            />
            {productState.selectedPrice.discount?.stone_value && (
              <s className="mx-3">
                {" "}
                <CurrencyInr value={productState.selectedPrice.stone_value} />
              </s>
            )}
          </p>
        )}
        {!!productState.selectedPrice?.polki_value && (
          <p>
            <strong>Polki Value: </strong>
            <CurrencyInr
              value={
                productState.selectedPrice.discount?.polki_value
                  ? productState.selectedPrice.discount.polki_value
                  : productState.selectedPrice.polki_value
              }
            />
            {productState.selectedPrice.discount?.polki_value && (
              <s className="mx-3">
                {" "}
                <CurrencyInr value={productState.selectedPrice.polki_value} />
              </s>
            )}
          </p>
        )}
        {!!productState.selectedPrice?.titanium_value && (
          <p>
            <strong>Titanium Value: </strong>
            <CurrencyInr
              value={
                productState.selectedPrice.discount?.titanium_value
                  ? productState.selectedPrice.discount.titanium_value
                  : productState.selectedPrice.titanium_value
              }
            />
            {productState.selectedPrice.discount?.titanium_value && (
              <s className="mx-3">
                {" "}
                <CurrencyInr
                  value={productState.selectedPrice.titanium_value}
                />
              </s>
            )}
          </p>
        )}
        {!!productState.selectedPrice?.kundan_value && (
          <p>
            <strong>Kundan Value: </strong>
            <CurrencyInr
              value={
                productState.selectedPrice.discount?.kundan_value
                  ? productState.selectedPrice.discount.kundan_value
                  : productState.selectedPrice.kundan_value
              }
            />
            {productState.selectedPrice.discount?.kundan_value && (
              <s className="mx-3">
                {" "}
                <CurrencyInr value={productState.selectedPrice.kundan_value} />
              </s>
            )}
          </p>
        )}
        {!!productState.selectedPrice?.other_value && (
          <p>
            <strong>{productState.selectedPrice?.other_label}: </strong>
            <CurrencyInr value={productState.selectedPrice.other_value} />
          </p>
        )}
        {!!productState.selectedPrice?.making_charge && (
          <p>
            <strong>Making Charge: </strong>
            <CurrencyInr
              value={
                productState.selectedPrice.discount?.making_charge !== undefined
                  ? productState.selectedPrice.discount.making_charge
                  : productState.selectedPrice.making_charge_value
              }
            />
            {productState.selectedPrice.discount?.making_charge !==
              undefined && (
              <s className="mx-3">
                {" "}
                <CurrencyInr
                  value={productState.selectedPrice.making_charge_value}
                />
              </s>
            )}
          </p>
        )}
        <p>
          <strong>GST ({+productState.selectedPrice.gst_percent}%): </strong>
          <CurrencyInr
            value={
              productState.selectedPrice.discount
                ? productState.selectedPrice.discount.gst_value
                : productState.selectedPrice.gst_value
            }
          />
        </p>
        <p>
          <strong>Total: </strong>
          <CurrencyInr
            value={
              productState.selectedPrice.discount
                ? productState.selectedPrice.discount.total
                : productState.selectedPrice.total
            }
          />
          {productState.selectedPrice.discount && (
            <s className="mx-3">
              {" "}
              <CurrencyInr value={productState.selectedPrice.total} />
            </s>
          )}
        </p>
      </div>
    </>
  );
};

export default ProductDetailsPriceBreakTab;
